import { render, staticRenderFns } from "@/client/budget/views/acceptance/choose-fees/choose-fees.pug?vue&type=template&id=0005f9f8&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/choose-fees/choose-fees.scss?vue&type=style&index=0&id=0005f9f8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005f9f8",
  null
  
)

export default component.exports